import { getReadableLocationId, Region } from '../../utils/regions';
import { ICoordinates, IOfficeData, IPikData } from '../../../typings/api';

export interface IOffice {
  id: number;
  title?: string;
  publicUrl?: string;
  address?: string;
  phones?: string[];
  coordinates?: ICoordinates;
  locationId?: Region;
}

export function parseOffice(office: IOfficeData): IOffice {
  return {
    address: office.address,
    coordinates: office.coordinates,
    id: office.id,
    locationId: getReadableLocationId(office.locationId),
    phones: office.phones,
    title: office.title,
  };
}

export function mapOfficeData(pikData: IPikData): IOffice[] {
  return pikData.data.officeObjects.map(parseOffice);
}
